import { render, staticRenderFns } from "./ContestBannerWinnerComponent.vue?vue&type=template&id=224f243a"
import script from "./ContestBannerWinnerComponent.vue?vue&type=script&lang=js"
export * from "./ContestBannerWinnerComponent.vue?vue&type=script&lang=js"
import style0 from "./ContestBannerWinnerComponent.vue?vue&type=style&index=0&id=224f243a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports